<template>
    <PageHint v-if="checkRoles()" v-bind="props" />
</template>

<script>
import PageHint from './PageHint'

export default {
    name: 'PageHintRouter',
    components: {
        PageHint,
    },
    props: {

    },
    computed: {
        hint() {
            if (typeof this.$route.meta.hint === 'object') {
                for(const role of this.roles) {
                    if (this.$hasRole(role)) {
                        return this.$route.meta.hint[role]
                    }
                }

                return false
            }

            return this.$route.meta.hint ? this.$route.meta.hint : false
        },
        roles() {
            if (typeof this.$route.meta.hint === 'object') {
                return Object.keys(this.$route.meta.hint)
            }

            return this.$route.meta.roles ? this.$route.meta.roles : []
        },
        props () {
            return {
                hint: this.hint,
            }
        }
    },
    methods: {
        openModal() {
            this.showModal = true
        },
        checkRoles() {
            if (this.roles.length === 0) {
                return true
            }

            let hasRole = false
            this.roles.forEach(role => hasRole = hasRole || this.$hasRole(role))

            return hasRole
        }
    },
}
</script>